import React from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import noop from 'utils/noop';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { InvalidIdMessage } from 'modules/alerts/invalidIdMessage';
import {
  selectCatalogIsLoading,
  selectCatalogIsSubmitting,
  selectCatalogTableHeader,
  selectCatalogTableRows,
  getCatalogName,
  selectCatalogItemsTotal,
  selectCatalogTableFilters,
  selectCatalogIsDisplayTable,
  selectCatalogNamesOnlyCaseInsensitive,
  selectCatalogMetadataItems,
} from 'modules/catalogTable/selectors';
import {
  getCatalogFieldTypesUndefined,
  selectDefinedFieldTypes,
} from 'modules/catalogFieldTypes/selectors';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { fetchCatalogFieldTypesRequest } from 'modules/catalogFieldTypes/actions';
import { fireSegmentTrackCall } from 'modules/segment/actions';
import { selectUserProject, selectIsCatalogCollectionsFlagOn } from 'core/userContext';
import { CatalogTable } from './CatalogTable';

import {
  changeTablePageSize,
  createNewCatalogRequest,
  fetchPaginatedCatalogItems,
  removeCatalogItem,
  refreshTable,
  updateCatalogDisplaySetting,
} from '../actions';

// type Props = {
//   fetchCatalogFieldTypesRequest: (?string) => void,
//   fetchPaginatedCatalogItems: (string, Object) => void,
//   filters: Object,
//   match: *,
//   isCatalogCollectionsFlagOn: boolean,
//   updateCatalogDisplaySetting: (boolean) => void,
//   queries: Array<Object>,
//   tableName: string,
//   userProject: Object,
// };

export class CatalogTableWrapper extends React.Component {
  static defaultProps = {
    createNewCatalogRequest: noop,
    fetchPaginatedCatalogItems: noop,
    removeCatalogItem: noop,
    updateCatalogDisplaySetting: noop,
    fetchCatalogFieldTypesRequest: noop,
    fireSegmentTrackCall: noop,
  };
  componentDidMount() {
    const { match } = this.props;
    const tableName = _.get(match, 'params.tableName');
    this.props.fetchPaginatedCatalogItems(tableName, this.props.filters);
    // retrieve display setting from localStorage
    this.getCatalogDisplaySetting();
    this.getFieldTypes(tableName);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    const tableName = _.get(match, 'params.tableName');
    if (prevProps.match.url !== this.props.match.url) {
      this.props.fetchPaginatedCatalogItems(tableName, this.props.filters);
      this.getFieldTypes(tableName);
    }
    // in the off-chance isCatalogCollectionsFlagOn gets turned on?
    if (
      this.props.isCatalogCollectionsFlagOn &&
      prevProps.isCatalogCollectionsFlagOn !== this.props.isCatalogCollectionsFlagOn
    ) {
      this.getFieldTypes(tableName);
    }
  }

  getFieldTypes = (tableName) => {
    const { isCatalogCollectionsFlagOn } = this.props;
    if (isCatalogCollectionsFlagOn) {
      this.props.fetchCatalogFieldTypesRequest(tableName);
    }
  };

  getCatalogDisplaySetting = () => {
    const { localStorage } = window;
    if (localStorage && localStorage.getItem('catalogDisplayAsTable')) {
      const parsedCatalogDisplayAsJson = JSON.parse(localStorage.getItem('catalogDisplayAsTable'));
      this.props.updateCatalogDisplaySetting(parsedCatalogDisplayAsJson);
    }
  };

  render() {
    return this.props.tableName ? (
      <CatalogTable {...this.props} />
    ) : (
      <InvalidIdMessage
        idType="catalog"
        id={_.get(this.props, ['match', 'params', 'tableName'])}
        project={this.props.userProject}
      />
    );
  }
}

// type CatalogStateReducer = {
//   catalogsState: Object,
// };

const mapStateToProps = (state) => ({
  component: CatalogTable,
  isLoading: selectCatalogIsLoading(state),
  isSubmitting: selectCatalogIsSubmitting(state),
  headerRow: selectCatalogTableHeader(state),
  rowData: selectCatalogTableRows(state),
  tableName: getCatalogName(state),
  filters: selectCatalogTableFilters(state),
  total: selectCatalogItemsTotal(state),
  isDisplayTable: selectCatalogIsDisplayTable(state),
  catalogNames: selectCatalogNamesOnlyCaseInsensitive(state),
  isCatalogCollectionsFlagOn: selectIsCatalogCollectionsFlagOn(state),
  definedFields: selectDefinedFieldTypes(state),
  undefinedFields: getCatalogFieldTypesUndefined(state),
  userProject: selectUserProject(state),
  catalogMetadataItems: selectCatalogMetadataItems(state),
  canManageCatalogs: selectDoesUserHaveRbacPermission(state)(PROJECT_PERMISSIONS.ManageCatalogs),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeTablePageSize,
      createNewCatalogRequest,
      fetchPaginatedCatalogItems,
      removeCatalogItem,
      refreshTable,
      updateCatalogDisplaySetting,
      fetchCatalogFieldTypesRequest,
      fireSegmentTrackCall,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CatalogTableWrapper));
